import * as React from 'react';
export var LayoutContext = React.createContext({
    isInLayout: false,
    registerChild: function () { },
});
export var useParentLayout = function () { return React.useContext(LayoutContext); };
//# sourceMappingURL=Layout.context.js.map